import {useUser} from '@gaia/stores/user';
import {useAtomValue, useSetAtom} from 'jotai';
import {atomWithStorage} from 'jotai/utils';

// Set initial value to `true` so that premium users who have never toggled this
// setting will see layered mode by default.
const layeredModeAtom = atomWithStorage<boolean>('isLayered', true);

export function useLayeredModeState() {
    const {hasPremiumSubscription} = useUser();
    // footgun: beware accidental conditional hook via `&&` short-circuit
    return useAtomValue(layeredModeAtom) && hasPremiumSubscription;
}

export function useLayeredMode(): [boolean, (enabled: boolean) => void] {
    return [useLayeredModeState(), useSetAtom(layeredModeAtom)];
}
